import { getFloorLabel } from './floorLabelHandler';

export const FloorOptions = Array.from({ length: 22 }, (_, index) => index - 1).map((id) => {
  return { id: String(id), title: getFloorLabel(id) as string };
});
